import { render, staticRenderFns } from "./hospitalpanel.vue?vue&type=template&id=e33b2074"
import script from "./hospitalpanel.vue?vue&type=script&lang=js"
export * from "./hospitalpanel.vue?vue&type=script&lang=js"
import style0 from "./hospitalpanel.vue?vue&type=style&index=0&id=e33b2074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports